export const getMinibookIdFromSession = (): string | null => {
  try {
    if (typeof window === 'undefined') {
      return null
    }

    const minibookId = sessionStorage.getItem('tsMinibookId')
    return minibookId
  } catch {
    return null
  }
}
